import axios from "axios";

const AXIOS_CONFIG = {
    withCredentials: true,
}

const zAxios = axios.create(AXIOS_CONFIG)

export default zAxios;